"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * New Api\'s for all actions
 * Actions APIs
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: ggrigorian@tivo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionType = void 0;
/**
 * Type of action
 * @export
 * @enum {string}
 */
exports.ActionType = {
    Action: 'action',
    WatchFromProviderAction: 'watchFromProviderAction',
    WatchNowAction: 'watchNowAction',
    PlayRecordingAction: 'playRecordingAction',
    LiveTvAction: 'liveTvAction',
    SubscribeToSocuAction: 'subscribeToSocuAction',
    ModifyRecordingAction: 'modifyRecordingAction',
    AddSeasonStreamingVideoAction: 'addSeasonStreamingVideoAction',
    AddYearStreamingVideoAction: 'addYearStreamingVideoAction',
    RentAction: 'rentAction',
    OnePassAction: 'onePassAction',
    MultiOnePassAction: 'multiOnePassAction',
    WatchUnifiedCollectionAction: 'watchUnifiedCollectionAction'
};
